import type { ExcelAction } from "./types";
import { initRulesUI } from "../rules-ui";

/**
 * Reformat opens a full-task-pane overlay containing the rules
 * management UI. It's NOT an Office dialog — using a dialog would
 * prevent the rule editor / persona manager from opening (Office
 * limits an add-in to one active dialog at a time). The overlay
 * approach keeps us in the task-pane context so those sub-dialogs
 * can open as normal.
 */
export const reformat: ExcelAction = {
  id: "reformat",
  label: "Reformat",
  description:
    "Manage formatting rules: view, toggle, edit, delete, and run them against a selection, sheet, or workbook. Personas group rules into named bundles.",
  async run({ log }) {
    const overlay = document.getElementById("reformat-overlay");
    if (!overlay) {
      log("Reformat overlay missing in DOM", "error");
      return;
    }
    log("opening Reformat…");
    overlay.hidden = false;

    // Wire close (only once — initRulesUI handles its own multi-init).
    const closeBtn = document.getElementById("reformat-close");
    if (closeBtn && !closeBtn.dataset.wired) {
      closeBtn.dataset.wired = "1";
      closeBtn.addEventListener("click", () => {
        overlay.hidden = true;
      });
    }

    try {
      await initRulesUI();
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      log(`Reformat init failed: ${message}`, "error");
    }
  },
};
